import GATSBY_COMPILED_MDX from "/Users/maxime/Code/maximetouroute.github.io/src/pages/2022-07-01-smart-faune/index.mdx";
import React from 'react';
import LayoutRoot from '../LayoutRoot/LayoutRoot';
import 'moment';
import {MDXProvider} from '@mdx-js/react';
import SEO from '../../SEO/SEO';
import {Link} from 'gatsby';
import {SHORTCODES} from '../../mdx-components/shortcodes';
import {nextPrevLinkCSS, coverBandCSS, punchlineCSS, subtextCSS} from './styles';
import {articleCSS, cardCSS} from '../articleStyles';
import {Container, Typography, Button} from '@mui/material';
import {makeAccentColor} from '../accentColorCreator';
import {jsx as ___EmotionJSX} from "@emotion/react";
function Template(_ref) {
  let {data: {mdx}, children, location, pageContext: {previousPost, nextPost, langCode}} = _ref;
  const previousPostHtml = previousPost ? ___EmotionJSX(Link, {
    to: previousPost.frontmatter.path + "#content"
  }, ___EmotionJSX(Button, {
    variant: "text",
    style: {
      color: mdx.frontmatter.color ? mdx.frontmatter.color : makeAccentColor(mdx.frontmatter.image.colors.vibrant)
    }
  }, "\u2190 ", previousPost.frontmatter.title)) : ___EmotionJSX("div", null);
  const nextPostHtml = nextPost ? nextPost && ___EmotionJSX(Link, {
    to: nextPost.frontmatter.path + "#content"
  }, ___EmotionJSX(Button, {
    variant: "text",
    style: {
      color: mdx.frontmatter.color ? mdx.frontmatter.color : makeAccentColor(mdx.frontmatter.image.colors.vibrant)
    }
  }, nextPost.frontmatter.title, " \u2192")) : ___EmotionJSX("div", null);
  const accentColor = mdx.frontmatter.color ? mdx.frontmatter.color : makeAccentColor(mdx.frontmatter.image.colors.vibrant);
  return ___EmotionJSX(LayoutRoot, {
    language: mdx.frontmatter.language,
    location: {
      ...location
    },
    accentColor: accentColor
  }, ___EmotionJSX(SEO, {
    title: mdx.frontmatter.title,
    description: mdx.frontmatter.description || mdx.frontmatter.subtitle,
    image: mdx.frontmatter.image.childImageSharp.gatsbyImageData.images.sources[0],
    pathname: mdx.frontmatter.path,
    article: true,
    langCode: langCode
  }), ___EmotionJSX("div", {
    css: coverBandCSS,
    id: "content"
  }, ___EmotionJSX(Typography, {
    variant: "h1",
    style: punchlineCSS
  }, mdx.frontmatter.title), ___EmotionJSX(Typography, {
    variant: "h2",
    style: subtextCSS
  }, mdx.frontmatter.subtitle), ___EmotionJSX("div", {
    css: nextPrevLinkCSS
  }, previousPostHtml, nextPostHtml)), ___EmotionJSX("div", {
    css: cardCSS
  }, ___EmotionJSX(Container, {
    maxWidth: "md"
  }, ___EmotionJSX("article", {
    itemScope: true,
    itemType: "http://schema.org/BlogPosting"
  }, ___EmotionJSX("div", {
    css: articleCSS
  }, ___EmotionJSX(MDXProvider, {
    components: SHORTCODES
  }, children)), ___EmotionJSX("div", {
    css: nextPrevLinkCSS
  }, previousPostHtml, nextPostHtml)))));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Template, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
const articlePageQuery = "4150318831";
